module.exports = __webpack_public_path__ + "img/CrossDoc-monogram.0427bb48.svg";